export default "__VITE_ASSET__B7elnlO0__$_?format=webp__"